import { render, staticRenderFns } from "./FleetTruckRevisions.vue?vue&type=template&id=12909096&scoped=true&"
import script from "./FleetTruckRevisions.vue?vue&type=script&lang=js&"
export * from "./FleetTruckRevisions.vue?vue&type=script&lang=js&"
import style0 from "./FleetTruckRevisions.vue?vue&type=style&index=0&id=12909096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12909096",
  null
  
)

export default component.exports